import { showFailToast } from 'vant';
import axios from 'axios';
import qs from 'qs';
import sha1 from 'crypto-js/sha1';
import md5 from 'crypto-js/md5';
import Cookies from 'js-cookie';
import envConfig from '@/config';
import { postToken } from '@/utils';
import { getCustomAgent } from '@/utils';
import { randomUUID } from 'cfmoto-utils';

function decodeDataComponent(str) {
  try {
    return decodeURIComponent(str);
  } catch (e) {
    return str;
  }
}

const baseURL = envConfig[`VUE_APP_${envConfig.env.toUpperCase()}_BASE_URL`];
const instance = axios.create({
  baseURL,
  timeout: 100000,
  paramsSerializer(params) {
    return qs.stringify(params, { arrayFormat: 'repeat' });
  },
});

// 加签
instance.interceptors.request.use((request) => {
  console.log(request);
  console.log(request.url);
  console.log(request.params);
  console.log(Object.keys({ id: 3, iconUrl: 'https://cfmoto.oss-cn-hangzhou.aliyuncs.com/IMD/social/Icon/ic_hnl3.png', content: '发帖子分享骑行经历', type: 2, activeFlag: true, abledFlag: true }).sort());
  const appConfig = envConfig[`VUE_APP_${envConfig.env.toUpperCase()}_CONFIG`];
  const params = JSON.parse(JSON.stringify(request.params || {}));
  const query = qs.stringify(params, { arrayFormat: 'repeat', encode: false });
  const data = decodeDataComponent(!Object.keys(request.data || {}).length || request.data instanceof FormData ? '' : typeof request.data === 'string' ? request.data : JSON.stringify(request.data || ''));
  const queryError = /error/.test(window.location.href) ? '&error=' + new Date().getTime() : '';
  const nonce = randomUUID();
  const timestamp = new Date().getTime();
  const signature = `${query}${queryError}${data}appId=${appConfig.appId}&nonce=${nonce}&timestamp=${timestamp}${appConfig.appSecret}`;
  const signatureMd5 = md5(sha1(signature).toString()).toString();
  const signatureParam = `appId=${appConfig.appId}&nonce=${nonce}&timestamp=${timestamp}`;

  console.log(`=====  加签start =====`);
  console.log(`appId:${appConfig.appId}`);
  console.log(`appSecret:${appConfig.appSecret}`);
  console.log(`params:${JSON.stringify(params)}`);
  console.log(`query:${query}`);
  console.log(`data:`, data);
  console.log(`nonce:${nonce}`);
  console.log(`timestamp:${timestamp}`);
  console.log(`signatureParam:${signatureParam}`);
  console.log(`拼接后：${signature}`);
  console.log(`加密后：${signatureMd5}`);

  console.log(`=====  加签end =====`);

  request.headers['Cfmoto-X-Sign'] = `${signatureMd5}`;
  request.headers['Cfmoto-X-Sign-Type'] = `0`;
  request.headers['Cfmoto-X-Param'] = `${signatureParam}`;
  console.log(request.headers);
  return request;
});

if (envConfig.env === 'development') {
  instance.interceptors.request.use((request) => request);
  instance.interceptors.response.use((response) => {
    console.log(`请求${response.config.url.replace(new RegExp(response.config.baseURL), '')}返回的Mock数据:`);
    console.dir(response.data);
    return response;
  });
}

// 拦截器
instance.interceptors.request.use(
  async (request) => {
    // console.log('安卓打印');
    // console.log(postToken());
    // console.log(window.native);
    // localStorage.setItem('token', JSON.stringify('TK-1635296747-9yriOTR65VTqIl4a3MfjI3AOPbPEZH2g'));
    const token = postToken() || JSON.parse(localStorage.getItem('token') || '""');
    const userId = JSON.parse(localStorage.getItem('userId') || '""');
    Cookies.set('ticket', token);
    Cookies.set('user_id', userId);
    request.withCredentials = true;
    // request.headers['version'] = config.version;
    if (token && !request.headers['Authorization']) {
      request.headers['Authorization'] = token;
      request.headers['applet-token'] = token;
    } else {
      request.headers['Authorization'] = 'YyPhuktDZtOnnaWlOepyBheBWRzWQI3';
      request.headers['applet-token'] = 'YyPhuktDZtOnnaWlOepyBheBWRzWQI3';
    }
    console.log('请求头信息');
    console.log('--userId', userId);
    console.log('--token', token);
    console.log(request.url);
    console.log(getCustomAgent());
    request.headers['Cfmoto-User-Agent'] = getCustomAgent();

    return request;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => {
    // 阻止options
    if (response.config.method.toLowerCase() === 'options') return false;
    const { to } = response.config;
    const meta = (to || {}).meta || {};
    if (response.status !== 200 && meta.auth !== 0) {
      return Promise.reject(response);
    }
    return response.data;
  },
  (error) => {
    const { to } = error.response.config;
    const meta = (to || {}).meta || {};
    if (meta.auth === 0) return Promise.resolve(error.response.data);
    if (error.message.indexOf('code 401') > -1) {
      showFailToast('登录失效，请重新登录');
    } else if (error.message.indexOf('code 404') > -1) {
      showFailToast('数据不存在');
    } else if (error.message.indexOf('timeout of') > -1) {
      showFailToast('请求超时了');
    } else {
      showFailToast('系统繁忙，请稍候再试！');
      Promise.reject('系统繁忙，请稍候再试！');
    }
    return Promise.reject(error);
  }
);

export default instance;
